import React from 'react';

import ProductMap from '../../product/components/product-map';
import ProductCard from '../../product/components/product-card';
import ProductShowPlaceHolder from '../../product/components/product-show-placeholder';

class VWAProductList extends React.PureComponent {
    productItem = (product, key, enableAppPDP, className, i, placeholder) => {
        const {
            toggleCompareDrag,
            disableCompare,
            slugKey,
            pg='test:dlp'
        } = this.props;

        if(placeholder){
            return <ProductShowPlaceHolder product={product} />
        }
        
        return (
            <ProductCard
                key={key}
                product={product}
                fetchSpecs={this.fetchTechSpecs}
                toggleCompareDrag={toggleCompareDrag}
                disableCompare={disableCompare}
                jumpInfo={{ slugKey, pg: pg.split(":").pop() }}
                enableAppPDP={enableAppPDP}
                saleCalloutPath="violatorMsg"
                hideMktDiff={true}
            />
        );
    }

    render() {
        const {
            enableAppPDP=true,
            results
        } = this.props;

        return (
            <div className="products-list">
                <ProductMap
                    products={results}
                    productItem={this.productItem}
                    enableAppPDP={enableAppPDP}
                    customPlaceHolder={true}
                    v2={true}
                />
            </div>
        );
    }
}

export default VWAProductList;
